// Set the copyright year to the current year.
// SAM writes the year into the page when it publishes the page.
// This script keeps the year correct until the next publish.
document.querySelectorAll("[data-current-year]").forEach(($year) => {
  $year.textContent = new Date().getFullYear();
});
